<div class="item-list-component">
  <div class="grid-buttons">
    <dx-button hint="{{ 'SHARED.ADD' | translate }}" icon="add" (onClick)="add()"></dx-button>
  </div>

  <dx-data-grid id="printSection"
                [dataSource]="items"
                [showBorders]="true"
                [allowColumnReordering]="true"
                [hoverStateEnabled]="true"
                [columnAutoWidth]="true"
                [rowAlternationEnabled]="true"
                (onRowClick)="editItem($event)">
    <dxo-selection mode="single"></dxo-selection>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-paging [pageSize]="pageSize"></dxo-paging>
    <dxo-pager [visible]="true"
               [showPageSizeSelector]="true"
               [allowedPageSizes]="[5, 10, 20, 30, 40, 50, 100, 200]"
               [showNavigationButtons]="true"
               [showInfo]="true"
               infoText="{2} {{ 'SHARED.PAGINATION_TEXT_PLACEHOLDER' | translate | slice:2 }}">
    </dxo-pager>

    <dxi-column [editorOptions]="{ showClearButton: true }"
                dataType="string"
                dataField="saleUnitNameText"
                caption="{{ 'PRODUCT.SALE_UNIT' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }"
                dataType="number"
                dataField="amount"
                caption="{{ 'PRODUCT.AMOUNT' | translate }} ({{ getTranslation(priceUnit?.name) }})">
    </dxi-column>
    <dxi-column type="buttons" [width]="70">
      <dxi-button hint="{{ 'SHARED.EDIT' | translate }}" icon="edit" [onClick]="editItem"></dxi-button>
      <dxi-button hint="{{ 'SHARED.DELETE' | translate }}" icon="trash" [onClick]="deleteItem"></dxi-button>
    </dxi-column>
  </dx-data-grid>
</div>

<sale-unit-component (onAdded)="onSaleUnitAdded($event)" (onUpdated)="onSaleUnitUpdated($event)"></sale-unit-component>
